import React from "react";
import { Alert, Spinner } from "react-bootstrap";
import { useApps } from "../../hooks/Dashboard/Apps/useApps";
import { useAppModal } from "../../hooks/Dashboard/Apps/useAppModal";
import AppsTable from "./AppsTable";
import "../../assets/css/Apps/AppsList.css";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import AppModal from "./AppModal";

const AppsList = () => {
  const {
    filteredApps,
    loading,
    error,
    showDeleteModal,
    selectedApp,
    searchTerm,
    handleDeleteAppWithConfirmation,
    handleDeleteModalToggle,
    handleDeleteApp,
    setSearchTerm,
  } = useApps();

  const {
    modalMode,
    editAppData,
    handleEditApp,
    handleOpenAdd,
    handleCloseModal,
  } = useAppModal();
  return (
    <div className={"container"}>
      <div className="header">
        <h2 className="title">Apps</h2>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Search by station name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="searchBar"
          />
          <button className="addButton" onClick={handleOpenAdd}>
            <span>+</span> New App
          </button>
        </div>
      </div>

      {error && (
        <Alert variant="danger" className={"errorAlert"}>
          {error}
        </Alert>
      )}

      {loading ? (
        <div className={"loadingContainer"}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <AppsTable
          apps={filteredApps}
          onEdit={handleEditApp}
          onDelete={handleDeleteAppWithConfirmation}
        />
      )}

      {showDeleteModal && (
        <ConfirmDeleteModal
          show={showDeleteModal}
          app={selectedApp}
          onClose={handleDeleteModalToggle}
          onConfirm={handleDeleteApp}
        />
      )}
      {modalMode && (
        <AppModal
          isOpen={modalMode !== null}
          onClose={handleCloseModal}
          mode={modalMode}
          initialData={editAppData}
        />
      )}
    </div>
  );
};

export default AppsList;
